import { Sparkles, ArrowRight } from 'lucide-react';
import { resolveTenantProductName } from '../../lib/whiteLabelBranding';

interface GuestModeHeaderIndicatorProps {
  onOpenSignupModal: () => void;
  isDark?: boolean;
}

export function GuestModeHeaderIndicator({ onOpenSignupModal, isDark = true }: GuestModeHeaderIndicatorProps) {
  const productName = resolveTenantProductName();
  return (
    <div className={`w-full border-b px-4 py-2 flex items-center justify-between text-xs font-sans ${
      isDark
        ? 'bg-[#0a151b] border-[#3bf4ce]/20 text-zinc-300'
        : 'bg-teal-50/80 border-teal-200 text-teal-900'
    }`}>
      <div className="flex items-center gap-2">
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded font-mono text-[10px] uppercase font-bold tracking-wider ${
          isDark ? 'bg-[#3bf4ce]/15 text-[#3bf4ce]' : 'bg-teal-600 text-white'
        }`}>
          <Sparkles className="w-3 h-3" />
          Demo Mode
        </span>
        <span className="hidden sm:inline font-medium">
          You’re exploring {productName} with sample data.
        </span>
      </div>

      <button
        type="button"
        onClick={onOpenSignupModal}
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold transition-all ${
          isDark
            ? 'bg-[#3bf4ce] text-black hover:bg-[#34d399] shadow-sm shadow-[#3bf4ce]/20'
            : 'bg-teal-700 text-white hover:bg-teal-800'
        }`}
      >
        <span>Create Free Account</span>
        <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}

export default GuestModeHeaderIndicator;
